export default __webpack_public_path__ + "static/Inter-Italic-b336f634e8ea19735f449b400617bc3b.woff";